<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="注册时间"
                        prop="registertime_range">
            <el-date-picker
                v-model="search.registertime_range"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="最近出现时间"
                        prop="appeartime_range">
            <el-date-picker
                v-model="search.appeartime_range"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item label="用户当前状态"
                        prop="currentstatus">
            <el-select v-model="search.currentstatus"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in options.currentstatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @sort-change="sortChange">
        <el-table-column prop="userid"
                         label="用户ID"
                         min-width="90" />
        <el-table-column prop="cellphone"
                         label="手机号"
                         min-width="90">
          <template slot-scope="scope">
            <router-link style="text-decoration:none"
                         :to="'/users/detail/info?userid='+scope.row.userid">
              <span style="color:rgb(88,157,248);">{{scope.row.cellphone}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="用户名称"
                         min-width="90" />
        <el-table-column prop="registertime"
                         label="注册时间"
                         min-width="90" />
        <el-table-column prop="currentstatus"
                         label="用户当前状态"
                         min-width="90">
          <template slot-scope="scope">
            <span v-for="item in options.currentstatus"
                  v-if="item.value === parseInt(scope.row.currentstatus)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date"
                         label="最近出现时间"
                         sortable="custom"
                         min-width="120" />
        <el-table-column prop="distance"
                         label="与门店距离(km)"
                         sortable
                         min-width="90" />
        <el-table-column prop="last_reviewed_time"
                         label="最后一个任务审核通过时间"
                         sortable="custom"
                         min-width="120" />
        <el-table-column prop="last_reviewed_customer"
                         label="最后一个通过的任务所属客户"
                         min-width="90" />
      </el-table>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import moment from 'moment'

export default {
  mixins: [table],
  data () {
    return {
      search: {
        registertime_range: [],
        appeartime_range: [],
        currentstatus: null,
      },
      searchRules: {}
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.options,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('taskNearbyUsers', params)
    },
    sortChange (param) {
      const { prop, order } = param
      const nullDatas = this.table.filter(item => !item[prop])
      if (order === 'descending') {
        this.table = this.table.filter(item => item[prop]).sort((a, b) => {
          return moment(b[prop]).valueOf() - moment(a[prop]).valueOf()
        })
      } else {
        this.table = this.table.filter(item => item[prop]).sort((a, b) => {
          return moment(a[prop]).valueOf() - moment(b[prop]).valueOf()
        })
      }
      this.table.push(...nullDatas)
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task/pages/TaskNearbyUsers.vue